import { appConfig } from '../../config';

const HOTJAR_SCRIPT_ID = 'hotjar-script';

// This retains the existing locally-hosted Hotjar loader, while ensuring no
// Hotjar script is inserted (and therefore no Hotjar request can be made) when
// the integration is disabled for an intranet build.
export const initializeHotjar = () => {
  if (!appConfig.enableHotjar || document.getElementById(HOTJAR_SCRIPT_ID)) return;

  window.hj = window.hj || function hotjarQueue() {
    (window.hj.q = window.hj.q || []).push(arguments);
  };
  window._hjSettings = { hjid: 2439597, hjsv: 6 };

  const script = document.createElement('script');
  script.id = HOTJAR_SCRIPT_ID;
  script.async = true;
  script.src = `${process.env.PUBLIC_URL}/lib/hotjar.js`;
  document.head.appendChild(script);
};
